// Drag-drop file upload — uploads to /api/attachments.
import { useState, useRef } from "react";
import { UploadCloud, X, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/api/client";
import { toast } from "sonner";

const ACCEPT = ".pdf,.jpg,.jpeg,.png,.docx,.xlsx";

export function FileUpload({ linkedEntity, linkedId, onUploaded, testId = "file-upload" }) {
  const inputRef = useRef();
  const [dragging, setDragging] = useState(false);
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (files) => {
    if (!files?.length) return;
    setUploading(true);
    for (const file of files) {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("linked_entity", linkedEntity);
      fd.append("linked_id", linkedId);
      try {
        const { data } = await api.post("/attachments", fd, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        toast.success(`${file.name} yüklendi`);
        onUploaded?.(data);
      } catch (e) {
        toast.error(formatApiError(e));
      }
    }
    setUploading(false);
  };

  return (
    <div
      data-testid={testId}
      onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={(e) => {
        e.preventDefault(); setDragging(false);
        handleFiles(e.dataTransfer.files);
      }}
      className={`border-2 border-dashed rounded-md p-6 text-center transition-colors cursor-pointer ${
        dragging ? "border-primary bg-muted/50" : "border-border hover:border-muted-foreground"
      }`}
      onClick={() => inputRef.current?.click()}
    >
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPT}
        multiple
        className="hidden"
        onChange={(e) => handleFiles(e.target.files)}
        data-testid={`${testId}-input`}
      />
      <UploadCloud className="mx-auto h-8 w-8 text-muted-foreground mb-2" />
      <p className="text-sm font-medium">Dosyayı buraya sürükleyin veya seçmek için tıklayın</p>
      <p className="text-xs text-muted-foreground mt-1">PDF, JPG, PNG, DOCX, XLSX · Max 20 MB</p>
      {uploading && <p className="text-xs text-primary mt-2">Yükleniyor...</p>}
    </div>
  );
}
